import { InfoServer } from '../InfoServer';
/**
 * FactoryInfoServer
 * Classe resonsável por armazenar as informações do servidor e fazer a conexão atráves de IP, porta entre outras informações
 */
export class FactoryInfoServer {
    static buildInfoServer(environment) {
        let infoServer = new InfoServer();
        infoServer.protocol = environment.protocol;
        infoServer.port = environment.port;
        infoServer.host = environment.host;
        infoServer.context = environment.context;
        infoServer.apiroot = environment.apiroot;
        return infoServer;
    }
}
